var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5102,
    cy: 24,
    rx: 23.5102,
    ry: 24,
    fill: "#175FFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1646 30.898V28.8126H25.3604C26.3076 28.8126 27.1059 28.4803 27.7552 27.8157C28.4045 27.1511 28.7292 26.3452 28.7292 25.398C28.7292 24.4813 28.4045 23.6831 27.7552 23.0032C27.1059 22.3234 26.3076 21.9834 25.3604 21.9834H19.1729L21.4417 24.2751L19.975 25.7418L15.1854 20.9522L19.975 16.1626L21.4417 17.6063L19.1729 19.898H25.3375C26.8653 19.898 28.1639 20.4327 29.2333 21.5022C30.3028 22.5716 30.8375 23.8702 30.8375 25.398C30.8375 26.9258 30.3028 28.2244 29.2333 29.2938C28.1639 30.3633 26.8653 30.898 25.3375 30.898H18.1646Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoEnable);
export default __webpack_public_path__ + "static/media/undo_enable.594b5f8b6934ebfdbad59d8f2ed82766.svg";
export { ForwardRef as ReactComponent };